'use client';

import './styles/default.scss';

type ExclusivePreLaunchTrailerPortraitProps = {
    openModalButtonUrl?: string;
    handleWidgetClick: () => void;
};

export const ExclusivePreLaunchTrailerPortrait: React.FC<ExclusivePreLaunchTrailerPortraitProps> = ({
    openModalButtonUrl,
    handleWidgetClick
}) => {
    return (
        <div className="exclusive-prelaunch__trailer--portrait" onClick={handleWidgetClick} role="button">
            {openModalButtonUrl && (
                <div className="view-trailer-button">
                    <img src={openModalButtonUrl} alt="Open Modal" />
                </div>
            )}
        </div>
    );
};
